import styled from '@emotion/styled';
import { mediaQueries, remCalc } from '../../css';

const StyledWrapper = styled('div')(() => ({
    display: 'flex',
}));

const StyledTeaser = styled('div')(() => ({
    display: 'inline-block',
    width: `${remCalc(130)}`,
    marginRight: remCalc(8),
    [mediaQueries.medium]: {
        width: `${remCalc(200)}`,
        marginRight: remCalc(16),
    },
    [mediaQueries.large]: {
        width: `${remCalc(250)}`,
    },
    [mediaQueries.xxlarge]: {
        width: `${remCalc(270)}`,
    },
}));

export { StyledTeaser, StyledWrapper };
